module.exports = __webpack_public_path__ + "static/img/10.adbca8d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/7/eng/10.png
// module id = 0tcz
// module chunks = 0